var app = require('./index');

log = function(msg) {console.log(msg)};

require('./account')
require('./faq')
require('./login')
require('./searchResults')
require('./siteNav')
require('./songLists')
require('./songs')
require('./songSearchForm')
require('./subscribe')
require('./usage')